import { createSlice } from "@reduxjs/toolkit";

interface SidebarState {
  collapsed: boolean;
}

const initialState: SidebarState = {
  collapsed: JSON.parse(localStorage.getItem("collapsed") || "false"),
};

const sidebarSlice = createSlice({
  name: "sidebar",
  initialState,
  reducers: {
    // Action um die Sidebar groß oder klein einzustellen
    toggleSidebar: (state) => {
      state.collapsed = !state.collapsed;
      localStorage.setItem("collapsed", JSON.stringify(state.collapsed)); // Speichern in localStorage
    },
  },
});

export const { toggleSidebar } = sidebarSlice.actions;

export default sidebarSlice.reducer;
